import {Route,Routes} from "react-router-dom"
import Home from "./MainPage/Home"

const Paths=()=>
{
    return(
        <Routes>
            <Route path="/" element={<Home/>}/>
        </Routes>
    )
}
export default Paths